import { MenuItem } from '@mui/material'
import { When } from 'react-if'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import CustomMuiSelect from 'Theme/Select'

import { FINAL_ROUND, JUDGE_ROUNDS, JUDGE_TOP_ROUNDS, TIEBREAKER_ROUND, TOP_10_ROUND, TOP_15_ROUND } from '../constants'
import { getAllRoundsValue, getJudgesRound } from '../utils'

export const JudgesRoundSelector = ({ roundNames, judge, onSelect, sx, handleDeleteJudge, ownerId }) => {
  const withTopRounds = roundNames?.length && roundNames.some((round) => round.includes('top'))
  const judgeRounds = getJudgesRound(judge, withTopRounds)
  const allRoundsValue = getAllRoundsValue(roundNames)
  const options = withTopRounds
    ? roundNames.includes(TOP_15_ROUND)
      ? {
          [allRoundsValue]: JUDGE_ROUNDS.all,
          [JSON.stringify([TOP_15_ROUND, TOP_10_ROUND, FINAL_ROUND, TIEBREAKER_ROUND])]: JUDGE_TOP_ROUNDS[TOP_15_ROUND],
        }
      : {
          [allRoundsValue]: JUDGE_ROUNDS.all,
          [JSON.stringify([TOP_10_ROUND, FINAL_ROUND, TIEBREAKER_ROUND])]: JUDGE_TOP_ROUNDS[TOP_10_ROUND],
        }
    : JUDGE_ROUNDS
  const isSelectedRoundExists = Object.keys(options).includes(judgeRounds)

  return (
    <CustomMuiSelect
      value={judgeRounds}
      sx={sx}
    >
      {Object.keys(options).map((item) => (
        <MenuItem
          value={item}
          key={item}
          onClick={() => {
            try {
              onSelect(JSON.parse(item))
            } catch (e) {
              onSelect(item)
            }
          }}
        >
          {options[item]}
        </MenuItem>
      ))}
      {!isSelectedRoundExists && (
        <MenuItem
          sx={{ display: 'none' }}
          value={judgeRounds}
          onClick={() => {
            onSelect(judgeRounds)
          }}
        >
          Invalid selection
        </MenuItem>
      )}
      <When condition={judge.user_id !== ownerId}>
        <MenuItem
          onClick={() => handleDeleteJudge(judge.user_id)}
          sx={(theme) => ({ color: theme.palette.error.main })}
        >
          <FAIcon iconClassName={FA_ICONS.TRASH} />
          Remove judge
        </MenuItem>
      </When>
    </CustomMuiSelect>
  )
}
